import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { Router, ActivatedRoute } from '@angular/router';
import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { MyMenuService } from '../../../tool/service/menu.service';

import { HomeComponent } from '../../../main/sys/home/home.component';

import { SubscriptService } from '../../../tool/service/header.service';
import { Subject, Observable } from 'rxjs';



@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: '登出' }];

  //基本資料
  USR_AccountInfo_ID: string;
  USR_EmployeeInfo_ID: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  CompanyName:string;
  authChangeSub:any;
  USR_POSEmployeeInfo_ID: string;
  //查詢的門市
  storeSelectList: selectData[];
  selectORG_Store_ID: number;
  menuSub : any

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private cookieService: CookieService,
    private _router: Router,
    private breakpointService: NbMediaBreakpointsService,
    private http: HttpClient,
    private ms: MyMenuService,
    private hs: SubscriptService,
    private home: HomeComponent) {

    

      console.log("註冊大菜單")
      this.menuSub = menuService.onItemClick().subscribe((event) => {
        console.log(event);
        if (event.item.title == "登出") {
          this.ms.logout();
        }
        
      });

      console.log('已訂閱 content AuthUpdata$')    
      this.hs.AuthUpdata$.subscribe(val => {
        console.log('hs 已收到content變動',val)
        this.getStoreList()
      });
  
  }


  ngOnInit() {
   
   


    this.USR_POSEmployeeInfo_ID = this.cookieService.get('USR_POSEmployeeInfo_ID');
    this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID') ? 
      "USR_AccountInfo_ID_"+this.cookieService.get('USR_AccountInfo_ID') :
        this.cookieService.get('USR_POSEmployeeInfo_ID') ?  
          "USR_POSEmployeeInfo_ID"+this.cookieService.get('USR_POSEmployeeInfo_ID') : null
    
    this.USR_EmployeeInfo_ID = this.cookieService.get('USR_EmployeeInfo_ID');
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'));
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.ORG_Store_ID = (cookie_sid && cookie_sid != '') ? parseInt(cookie_sid) : null




    this.currentTheme = this.themeService.currentTheme;
    // this.userService.getUsers()
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((users: any) => this.user = users.nick);

    this.user = new Object();
    this.user.name = this.cookieService.get('NickName');
    this.user.picture = this.cookieService.get('PhotoURL');
    this.CompanyName = this.cookieService.get('CompanyName'); 

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);


    if (this.USR_AccountInfo_ID != null) {
      this.getStoreList();
    }
  }

  ngOnDestroy() {

    if (this.menuSub) {
      this.menuSub.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  
  //開關左邊欄
  toggleSidebar(): boolean {
   
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }








  upSelect: boolean = false;
  //取得門市清單
  getStoreList() {//取得門市清單 USP_YOPOSWebGetStoreList

    console.log('hs 更新門市清單')


    this.http.post<any>('api/ORGStore/StoreList', {
      USR_AccountInfo_ID: this.USR_AccountInfo_ID ? this.USR_AccountInfo_ID : 'empty',
      USR_EmployeeInfo_ID: this.USR_EmployeeInfo_ID,
      ORG_Company_ID: this.ORG_Company_ID,
      USR_POSEmployeeInfo_ID: this.USR_POSEmployeeInfo_ID,
    }).subscribe({
      next: data => {
        this.storeSelectList = [];
        data.LIST.forEach(element => {
          //門市共用下拉選單
          var selectItem = new selectData();
          selectItem.value = element.ORG_Store_ID;
          selectItem.content = element.StoreName;
          this.storeSelectList.push(selectItem);
        });

        // 預設點第一個
        if (this.storeSelectList.length > 0) {
          let obj = this.storeSelectList.find(x=>x.value ==  this.ORG_Store_ID )
          if(obj)  {
            this.selectORG_Store_ID = obj.value
            this.selectStoreChange(obj.value)
          }        
          else{
            this.selectORG_Store_ID = this.storeSelectList[0].value
            this.selectStoreChange(this.storeSelectList[0].value)
          }
         
        }
        this.upSelect = !this.upSelect



      },
      error: error => {
        console.error('There was an error!', error);
      }
    });

  }
  //選擇門市
  selectStoreChange(event) {

   
   
    this.cookieService.set('ORG_Store_ID', event,1,'/');
    this.selectORG_Store_ID = event
    this.ORG_Store_ID = event

    console.log('hs變更了內容!')
    this.hs.AuthChangeSubject.next(event)
   

    this.ms.getMenu()
    this.home.GetContractRd();
  }





  // changeTheme(themeName: string) {
  //   this.themeService.changeTheme(themeName);
  // }

  // navigateHome() {
  //   this.menuService.navigateHome();
  //   return false;
  // }



}


class selectData {
  value: number;//
  content: string;//

}
